import { UntypedFormControl, ValidationErrors } from '@angular/forms';

export function EmailValidator(control: UntypedFormControl): ValidationErrors {
	// tslint:disable-next-line:max-line-length
	const emailRegex =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return !control.value || emailRegex.test(control.value) ? null : { email: true };
}

export function CustomerNoteZohoContentValidator(control: UntypedFormControl): ValidationErrors {
	// tslint:disable-next-line:max-line-length
	const zohoNoteRegex =
		/(?:(([12]\d{3} ?\/?.? ?(?:0[1-9]{1}|1[0-2]{1}|[1-9]) ?\/?.? ?(?:0[1-9]|[12]\d|3[01]|[1-9])) ?-?-? ?([a-zA-Z]{2,4}))|(([a-zA-Z]{3,}.? (?:1[0-9]|0[1-9]|[1-9]|3[0-1]|2[0-9]), 20[0-9]{2}) ?-? ([a-zA-Z]{2,4}))|(((?:[1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])\/?.?(?:[1-9]|0[1-9]|1[0-2])\/?.?[12]\d{3}) ?-? ?([a-zA-Z]{2,4}))|(((?:20[0-9]{2} ?\/? ?(?:1[3-9]|2[0-9]|3[0-1]) ?\/? ?(?:0[1-9]|1[0-2]|[1-9]))) ?-?-? ?([a-zA-Z]{2,4})))/;
	return !control.value || zohoNoteRegex.test(control.value) ? { customerNoteZohoContentRegex: true } : null;
}

export function EmojiNotAllowed({ value }): ValidationErrors {
	const emojiRegex = /[\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]/u;
	return emojiRegex.test(value) ? { emojiNotAllowed: true } : null;
}

export enum DefaultValidatorFunctions {
	EMOJI_NOT_ALLOWED
}

export const DefaultFieldValidators = {
	[DefaultValidatorFunctions.EMOJI_NOT_ALLOWED]: EmojiNotAllowed
};
